import { Screens } from '@shared/constants/screens';
import { IScreenOrderItem } from 'utils/buildFlowTransitions';
import { getRandomImage } from 'utils/getRandomLoadingImages';
import { FlowTransitions } from './appContext';

export interface UIState {
  loadingImage: string;
  isLoading: boolean;
  isLoadingSuccess: boolean;
}

export interface RouteState {
  pageName: {
    current: string | null;
    previous: string | null;
  };
}

export interface AppState {
  ui: UIState;
  route: RouteState;
  error: string | null;
  screenOrder: IScreenOrderItem[];
  flowTransitions: FlowTransitions;
}

export type AppAction =
  | { type: 'SET_LOADING'; payload: { isLoading: boolean } }
  | { type: 'SET_LOADING_IMAGE'; payload: string }
  | { type: 'SET_PAGE'; payload: string }
  | { type: 'SET_ERROR'; payload: string }
  | { type: 'CLEAR_ERROR' }
  | { type: 'SET_SCREEN_ORDER'; payload: { screenOrder: IScreenOrderItem[]; flowTransitions: FlowTransitions } };

export const initialAppState: AppState = {
  ui: {
    loadingImage: '',
    isLoading: false,
    isLoadingSuccess: false,
  },
  route: {
    pageName: {
      current: Screens.EMPLOYMENT_AND_INCOME,
      previous: null,
    },
  },
  error: null,
  screenOrder: [],
  flowTransitions: {},
};

export const APP_ACTIONS = {
  SET_LOADING: 'SET_LOADING',
  SET_LOADING_IMAGE: 'SET_LOADING_IMAGE',
  SET_PAGE: 'SET_PAGE',
  SET_ERROR: 'SET_ERROR',
  CLEAR_ERROR: 'CLEAR_ERROR',
  SET_SCREEN_ORDER: 'SET_SCREEN_ORDER',
} as const;

export const appReducer = (state: AppState, action: AppAction): AppState => {
  switch (action.type) {
    case APP_ACTIONS.SET_LOADING:
      return {
        ...state,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
          loadingImage: action.payload.isLoading ? getRandomImage() : '',
        },
      };

    case APP_ACTIONS.SET_PAGE:
      return {
        ...state,
        route: {
          ...state.route,
          pageName: {
            previous: state.route.pageName.current,
            current: action.payload,
          },
        },
      };
    
    case APP_ACTIONS.SET_SCREEN_ORDER:
      return { ...state, 
        screenOrder: action.payload.screenOrder,
        flowTransitions: action.payload.flowTransitions,
       };

    case APP_ACTIONS.SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case APP_ACTIONS.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const appActions = {
  setLoading: (isLoading: boolean): AppAction => ({
    type: APP_ACTIONS.SET_LOADING,
    payload: { isLoading },
  }),

  setPage: (pageName: string): AppAction => ({
    type: APP_ACTIONS.SET_PAGE,
    payload: pageName,
  }),

  setError: (error: string): AppAction => ({
    type: APP_ACTIONS.SET_ERROR,
    payload: error,
  }),

  clearError: (): AppAction => ({
    type: APP_ACTIONS.CLEAR_ERROR,
  }),
};
